import { ChatController } from './ChatController/ChatController';
import { observer } from 'mobx-react-lite';
import { action, makeObservable } from 'mobx';
import { ApiaUtil } from '../../objects';
import { IconButton } from '../forms';
import {
  MessageSubmitCallback,
  TChatControllerState,
} from './ChatController/types';

export class FloatingChatController extends ChatController<{
  isVisible: boolean;
}> {
  constructor(
    props: Partial<TChatControllerState>,
    onMessageSubmit: MessageSubmitCallback,
    private modalTitle?: string,
  ) {
    super({ ...props, isVisible: true }, onMessageSubmit);
    makeObservable({ open: action });
  }

  open(onClose: () => unknown) {
    ApiaUtil.instance.modals.open({
      variant: 'layout.common.newChat.assistant.floatingAssistant',
      defaultPosition: {
        bottom: '10px',
        right: '10px',
      },
      draggable: true,
      children: <this.Renderer />,
      onClose: onClose,
      title: this.modalTitle,
    });
  }

  Window = observer(() => {
    return this.state.isVisible ? (
      <IconButton
        className="chat_controller__open"
        icon="Magic"
        size="Md"
        variant="icon-outline"
        onClick={() => {
          this.state.isVisible = false;
          this.open(() => {
            this.state.isVisible = true;
          });
        }}
      />
    ) : null;
  });
}
